import React, { Fragment, useEffect, useState } from 'react'
import "../../../assets/css/master.css"
import { useDispatch, useSelector } from 'react-redux'
import { loaderActions } from '../../../_actions/loader.actions'
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices'
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session'
import { useNavigate } from 'react-router-dom'
import PrivacyPolicy from './PrivacyPolicy'
import TermsCondition from './TermsCondition'

const PrivacyPolicyAndTermsConditions = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sectionTab, setSectionTab] = useState('privacypolicy');
    const [UserId, setUserId] = useState(0);
    const user = useSelector(store => store.userstatus.tba);
    const [userRights, setUserRights] = useState(true);
    const [updateFetch, setUpdateFetch] = useState(false)

    const [policyData, setPrivacyPolicy] = useState()
    const [termsData, setTermAndCondition] = useState()

    //#region handle Rights
    useEffect(() => {
        let pagelink = user?.find(x => x?.PageLink?.toLowerCase() === window?.location?.pathname?.toLowerCase());
        let mid = user?.find(x => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x?.MenuId === pagelink?.MenuId).map((obj) => {
            setUserRights(obj);
        });
    }, [user])
    //#endregion

    //#region tab section on Click function
    const handleSections = (id) => {
        setSectionTab(id)
    }
    //#endregion

    const getTermAndPolicy = async () => {
        const policyDetails = await getAllData('/master/v1/getprivacypolicytermsconditions');

        if (policyDetails?.status) {
            setPrivacyPolicy(policyDetails?.data?.privacyPolicyDetails?.[0])
            setTermAndCondition(policyDetails?.data?.termsConditionsDetails)
            setUpdateFetch(false)
        }
    }

    async function fetchData() {
        dispatch(loaderActions.start());
        const statusoftoken = await verifytoken();
        if (statusoftoken) {
            const userdata = GetLocalStorage()
            setUserId(userdata?.userMasterID)
            await Promise.all([
                getTermAndPolicy()
            ])
            dispatch(loaderActions.end());
        }
        else {
            dispatch(loaderActions.end())
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    //#region Call All API
    useEffect(() => {
        if (updateFetch) {
            fetchData();
        }
    }, [updateFetch])


    useEffect(() => {
        fetchData();
    }, [])
    //#endregion


    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Privacy Policy & Terms & Conditions</h3>
            </div>
            <div className=" row mx-1">
                <div className="col-lg-12 col-md-12 col-sm-12 mb-lg-1">
                    <div className="faq_tab d-flex justify-content-center align-items-center flex-wrap">
                        <div className='container tab_section px-0'>
                            <ul className="nav nav-pills nav-justified mb-3 pt-3" id="pills-tab" role="tablist">

                                <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                                    <a className={`nav-link ${sectionTab === 'privacypolicy' ? 'active' : ''} `}
                                        id={'privacypolicy_id'} data-bs-toggle="pill"
                                        type="button" role="tab"
                                        aria-selected="false" onClick={(e) => handleSections('privacypolicy')}><strong>Privacy Policy</strong></a>
                                </li>


                                <li className="nav-item mx-lg-5 mx-md-1 mx-5 mt-1" role="presentation">
                                    <a className={`nav-link ${sectionTab === 'termsconditions' ? 'active' : ''} `}
                                        id={'termsconditions_id'} data-bs-toggle="pill"
                                        type="button" role="tab"
                                        aria-selected="false" onClick={(e) => handleSections('termsconditions')}><strong>Terms & Conditions</strong></a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid form_border pb-5 my-3">
                {
                    sectionTab === 'privacypolicy' ?
                        <PrivacyPolicy
                            policyData={policyData}
                            userRights={userRights}
                            setUpdateFetch={setUpdateFetch}
                        />
                        : sectionTab === 'termsconditions' ?
                            <TermsCondition
                                termsData={termsData}
                                userRights={userRights}
                                setUpdateFetch={setUpdateFetch}
                            />

                            : <> </>

                }
            </div>

        </>
    )
}

export default PrivacyPolicyAndTermsConditions